import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getCityDataAPI } from "../api/CityApi";

const initialState = {
    city: {},
    loading: false,
    successful: false,
    status: ''
}

export const getCity = createAsyncThunk(
  "blog/getCity",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await getCityDataAPI(payload);
      return response.data;
    } catch (err) {
      return rejectWithValue({
        errorMessage: err?.message,
      });
    }
  }
);

const citySlice = createSlice({
    name: "city",
    initialState,
    extraReducers: (builder) => {
        // get City
        builder.addCase(getCity.pending, (state) => {
            state.loading = true;
        });
        builder.addCase(getCity.fulfilled, (state, action) => {
            state.city = action?.payload;
            state.successful = false;
            state.loading = false;
        });
        builder.addCase(getCity.rejected, (state) => {
            state.loading = false;
        });
    },
});

export default citySlice.reducer;